import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { TaskAuditDataListQueryParamsInterface } from './definitions/task-audit-data-list-query-params.interface';
import { PagedResponseInterface } from '../../../classes/paged-response.interface';
import { TaskAuditDataListItemInterface } from './definitions/task-audit-data-list-item.interface';
import {
  UniqaSyncJobGetQueryParamsInterface
} from '../uniqa-sync-jobs/definitions/uniqa-sync-job-get-query-params.interface';

@Injectable()
export class GetTaskAuditDataService {
  constructor(
    private client: HttpClient,
    private configService: ConfigService
  ) {}

  public getAuditData(
    taskId: string,
    paramsArg: TaskAuditDataListQueryParamsInterface
  ): Observable<PagedResponseInterface<TaskAuditDataListItemInterface>> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/audit`;

    const params: HttpParams = this.createQueryParams(paramsArg);

    return this.client
      .get<PagedResponseInterface<TaskAuditDataListItemInterface>>(url, { params })
      .pipe(catchError((error) => throwError(() => handleProblem(error))));
  }

  private createQueryParams(
    paramsObj: UniqaSyncJobGetQueryParamsInterface
  ): HttpParams {
    let params = new HttpParams();

    Object.entries(paramsObj)
      .forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
          return;
        }

        const paramKey = key.charAt(0).toLowerCase() + key.slice(1);

        if (Array.isArray(value)) {
          value.forEach((item) => {
            params = params.append(paramKey, item.toString());
          });
        } else {
          params = params.set(paramKey, value.toString());
        }
    });

    return params;
  }
}
